export const DUMMY_ACCESS_TOKEN = "dummy"
export const DUMMY_ACCESS_TOKEN_EXPIRES_IN = 1200
